import React from "react";
import { LineChart } from "../../common/components/charts/line"
import CustomersByYearStore from "../CustomersByYearStore"
import { ChartDataConfig } from "../../common/components/charts/chartsHelper";
import { Loading } from "../../common/components/loading";

export default () => {

    const items = CustomersByYearStore.useAll();
    if (!items)
        return <Loading />;

    let years = items.map(x => x.year);
    const data = {
        labels: years.map(x => x.toString()),
        datasets: [{
            description: `Nuovi clienti`,
            values: items.map(x => x.new),
        }, {
            description: `Clienti dismessi`,
            values: items.map(x => x.dismissed),
        }]
    } as ChartDataConfig;

    return <LineChart
        key={new Date().valueOf()}
        title="ANDAMENTO CLIENTI ANNUALE"
        data={data}
        colorscheme={2}
    />
}